module.exports = __webpack_public_path__ + "static/media/Leadership.23ae8fdb.jpg";